<template>
  <dr-expansion-panel-editor 
    v-if="isInEditorMode"
    :class="evaluateClasses(classes)"
    :parentsWidgets="parentsWidgets"
    v-bind="$props"
    @deleteComponent="onDeleteComponentExpensionPanel"
    @modelChanged="onModelChanged"
    @callDataSourceAction="$emit('callDataSourceAction', $event)"
  />
  <dr-expansion-panel-component v-else-if="isVisible"
    :class="evaluateClasses(classes)"
    v-bind="$props"
    @callDataSourceAction="$emit('callDataSourceAction', $event)"
  />
</template>
<script>
import mixin from '../../mixins/base-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  components: {
    'dr-expansion-panel-editor': () => import('./dr-expansion-panel-editor'),
    'dr-expansion-panel-component': () => import('./dr-expansion-panel-component')
  },
  methods: {
    onDeleteComponentExpensionPanel(value) {
      this.$emit('deleteComponent', value)
    },
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    }
  }
}
</script>